import { getDocChatStorageOwner } from 'features/knowledgeDocumentViewer/utils/docChatStorageOwner'
import { type MutableRefObject, useRef } from 'react'

/**
 * The storage owner as of this component's last render. A tree being unmounted
 * because the owner changed never re-renders, so its flushes still see the
 * previous owner and are dropped.
 */
export function useRenderedDocChatStorageOwner(): MutableRefObject<
  string | null
> {
  const ownerRef = useRef(getDocChatStorageOwner())
  ownerRef.current = getDocChatStorageOwner()
  return ownerRef
}
